import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NavigationState {
  section: string,
  subSection: string,
  sideBarMenu: any,
  subSideBarMenu: any,
  isNavigationDropdownOpened: boolean;
  isAgreementPopupOpened: boolean;
  isLockScreenWarningPopupOpened: boolean;
  isSecurityPinPopupOpened: boolean;
  isDeletedAccountPopupOpened: boolean;
  isGroupAccessInvitePopupOpened: boolean;
  isLoadingPopupOpened: boolean;
  isLanguagePopupOpened: boolean;
  isSuscribedPopupOpened: boolean;
  isUpdateSeatsPopupOpened: boolean;
  isAddSeatsPopupOpened: boolean;
  isCancelSubscriptionPopupOpened: boolean;
  isSuspendedGroupPopupOpened: boolean;
  isAddPaymentMethodPopupOpened: boolean;
  isTicketDetailsPopupOpened: boolean;
  isDoctorsAccessAuthCodePopupOpened: boolean;
  isDeleteAccountPopupOpened: boolean;
  isBlockedAccountPopupOpened: boolean;
  isLoginAttemptsWarningPopupOpened: boolean;
}

const initialState: NavigationState = {
  section: '',
  subSection: '',
  sideBarMenu: null,
  subSideBarMenu: null,
  isNavigationDropdownOpened: false,
  isAgreementPopupOpened: false,
  isLockScreenWarningPopupOpened: false,
  isSecurityPinPopupOpened: false,
  isDeletedAccountPopupOpened: false,
  isGroupAccessInvitePopupOpened: false,
  isLoadingPopupOpened: false,
  isLanguagePopupOpened: false,
  isSuscribedPopupOpened: false,
  isUpdateSeatsPopupOpened: false,
  isAddSeatsPopupOpened: false,
  isCancelSubscriptionPopupOpened: false,
  isSuspendedGroupPopupOpened: false,
  isAddPaymentMethodPopupOpened: false,
  isTicketDetailsPopupOpened: false,
  isDoctorsAccessAuthCodePopupOpened: false,
  isDeleteAccountPopupOpened: false,
  isBlockedAccountPopupOpened: false,
  isLoginAttemptsWarningPopupOpened: false,
};

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setDashboardSection: (state, action: PayloadAction<string>) => {
        state.section = action.payload
    },
    setDashboardSubSection: (state, action: PayloadAction<string>) => {
        state.subSection = action.payload
    },
    setSideBarMenu: (state, action: PayloadAction<any>) => {
        // FIX: This reducer now ONLY sets the menu and does not touch the section.
        state.sideBarMenu = action.payload;
    },
    setSubSideBarMenu: (state, action: PayloadAction<any>) => {
      state.subSection = action.payload[0].section;
      state.subSideBarMenu = action.payload;
    },
    setIsNavigationDropdownOpened: (state, action: PayloadAction<boolean>) => {
      state.isNavigationDropdownOpened = action.payload;
    },
    setIsAgreementPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isAgreementPopupOpened = action.payload;
    },
    setIsLockScreenWarningPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isLockScreenWarningPopupOpened = action.payload;
    },
    setIsSecurityPinPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isSecurityPinPopupOpened = action.payload;
    },
    setIsDeletedAccountPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isDeletedAccountPopupOpened = action.payload;
    },
    setIsGroupAccessInvitePopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isGroupAccessInvitePopupOpened = action.payload;
    },
    setIsLoadingPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isLoadingPopupOpened = action.payload;
    },
    setIsLanguagePopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isLanguagePopupOpened = action.payload;
    },
    setIsSuscribedPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isSuscribedPopupOpened = action.payload;
    },
    setIsUpdateSeatsPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isUpdateSeatsPopupOpened = action.payload;
    },
    setIsAddSeatsPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isAddSeatsPopupOpened = action.payload;
    },
    setIsCancelSubscriptionPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isCancelSubscriptionPopupOpened = action.payload;
    },
    setIsSuspendedGroupPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isSuspendedGroupPopupOpened = action.payload;
    },
    setIsAddPaymentMethodPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isAddPaymentMethodPopupOpened = action.payload;
    },
    setIsTicketDetailsPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isTicketDetailsPopupOpened = action.payload;
    },
    setIsDoctorsAccessAuthCodePopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isDoctorsAccessAuthCodePopupOpened = action.payload;
    },
    setIsDeleteAccountPopupOpened: (state, action: PayloadAction<boolean>) => {
      state.isDeleteAccountPopupOpened = action.payload;
    },
    setIsBlockedAccountPopupOpened: (state, action: PayloadAction<boolean>) =>  {
      state.isBlockedAccountPopupOpened = action.payload;
    },
    setIsLoginAttemptsWarningPopupOpened: (state, action: PayloadAction<boolean>) =>  {
      state.isLoginAttemptsWarningPopupOpened = action.payload;
    },
    setResetNavigation: (state) => {
      state.section = '';
      state.subSection = '';
      state.sideBarMenu = null;
      state.isNavigationDropdownOpened = false;
      state.isAgreementPopupOpened = false;
      state.isLockScreenWarningPopupOpened = false;
      state.isSecurityPinPopupOpened = false;
      state.isDeletedAccountPopupOpened = false;
      state.isGroupAccessInvitePopupOpened = false;
      state.isLoadingPopupOpened = false;
      state.isLanguagePopupOpened = false;
      state.isSuscribedPopupOpened = false;
      state.isUpdateSeatsPopupOpened = false;
      state.isAddSeatsPopupOpened = false;
      state.isCancelSubscriptionPopupOpened = false;
      state.isSuspendedGroupPopupOpened = false;
      state.isAddPaymentMethodPopupOpened = false;
      state.isTicketDetailsPopupOpened = false;
      state.isDoctorsAccessAuthCodePopupOpened = false;
      state.isDeleteAccountPopupOpened = false;
      state.isBlockedAccountPopupOpened = false;
      state.isLoginAttemptsWarningPopupOpened = false;
    }
  },
});

export const {
  setDashboardSection,
  setDashboardSubSection,
  setSubSideBarMenu,
  setResetNavigation,
  setIsNavigationDropdownOpened,
  setIsAgreementPopupOpened,
  setIsLockScreenWarningPopupOpened,
  setIsSecurityPinPopupOpened,
  setIsDeletedAccountPopupOpened,
  setIsGroupAccessInvitePopupOpened,
  setIsLoadingPopupOpened,
  setIsLanguagePopupOpened,
  setIsSuscribedPopupOpened,
  setIsAddSeatsPopupOpened,
  setIsUpdateSeatsPopupOpened,
  setIsCancelSubscriptionPopupOpened,
  setIsSuspendedGroupPopupOpened,
  setIsAddPaymentMethodPopupOpened,
  setIsTicketDetailsPopupOpened,
  setIsDoctorsAccessAuthCodePopupOpened,
  setIsDeleteAccountPopupOpened,
  setIsBlockedAccountPopupOpened,
  setIsLoginAttemptsWarningPopupOpened,
  setSideBarMenu } = navigationSlice.actions;

export default navigationSlice.reducer;